import React, { useState } from 'react';

import classNames from 'classnames';

import Accordion from './Accordion';

const FAQs = () => {
  const [active, setActive] = useState<'lawyers' | 'clients'>('lawyers');

  const handleChangeActive = (val: typeof active) => {
    setActive(val);
  };
  return (
    <div className='min-h-[100vh]'>
      <div className='lg:pt-[188px] pt-[134px] 2xl:px-[68px] lg:px-12 md:px-6 px-4 lg:pb-[120px] pb-12'>
        <p className='text-l-primary font-bold lg:text-[40px] text-3xl'>
          Frequently Asked Questions
        </p>
        <div className='inline-flex bg-l-light-grey p-2 mt-12 rounded-md'>
          <div
            className={classNames(
              'lg:w-[159px] w-[120px] h-12 grid place-items-center rounded-md cursor-pointer',
              active === 'lawyers' && 'bg-l-primary'
            )}
            onClick={() => handleChangeActive('lawyers')}
          >
            <p
              className={classNames(
                'lg:text-base text-sm   font-semibold',
                active === 'lawyers' ? 'text-white' : 'text-l-primary'
              )}
            >
              For Lawyers
            </p>
          </div>
          <div
            className={classNames(
              'lg:w-[159px] w-[120px] h-12 grid place-items-center rounded-md cursor-pointer',
              active === 'clients' && 'bg-l-primary'
            )}
            onClick={() => handleChangeActive('clients')}
          >
            <p
              className={classNames(
                'lg:text-base text-sm  font-semibold',
                active === 'clients' ? 'text-white' : 'text-l-primary'
              )}
            >
              For Clients
            </p>
          </div>
        </div>
        {active === 'lawyers' && (
          <div className='flex flex-col mt-8 gap-3'>
            <Accordion
              question='How will I get paid?'
              answer='Clients pay appointment fees through online payments. You can withdraw your funds using your Bank Account, JazzCash Account, and Easypaisa Account. Once you request a withdrawal, you’ll receive your funds within 3-4 business days.'
            />
            <Accordion
              question='How can I get verified on Legal Avenue?'
              answer='There are 2 types of verifications. Email verification and ID verification.

Email verification: This verification is needed during account creation. 

ID Verification: ID verification is needed when you’re setting up your professional profile. To verify your identity, you are required to submit Front and Back pictures of your CNIC. '
            />
            <Accordion
              question='What documents do I need to provide for verification?'
              answer='For identity verification, you need to provide your CNIC (National ID Card). And for professional verification, you need to provide your License Number and a picture of License.'
            />
            <Accordion
              question='How long does the verification process take?'
              answer="The Legal Avenue team manually verifies the lawyer's credentials. The entire verification process can take 24 to 48 hours. "
            />
            <Accordion
              question='What should I do if my payment is delayed?'
              answer='If you face payment delays, or any other issue regarding payments, you can contact our team at info@legalavenue.pk. '
            />
          </div>
        )}
        {active === 'clients' && (
          <div className='flex flex-col mt-8 gap-3'>
            <Accordion
              question='When can I book my first appointment? '
              answer='You can book your first appointment after getting verified on Legal Avenue. When you create your account, you will be requested to verify your email. Once you get verified, you can start booking appointments. '
            />
            <Accordion
              question='What to do if the lawyer is not available at the time of appointment?'
              answer='If the lawyer is not available at the time of appointment, you can contact our support team at info@legalavenue.pk. Our support team will review your query and ensure whether the lawyer was available or not. 

If the lawyer was not available at the time of appointment, your appointment fee will be refunded to your wallet. You can only use this amount for future appointments. 

Note: There will be no refunds when your appointment is rescheduled. Refunds are only available if you haven’t requested to reschedule your appointment. 
  
'
            />
            <Accordion
              question=' Can I cancel an appointment and get a refund? '
              answer='No, you cannot cancel your appointments. You can only request to reschedule your appointments. When you request to reschedule an appointment, you cannot request a refund. 

Note: Refunds are only available when the lawyer is not available at the time of appointment and no rescheduling request is initiated. '
            />
            <Accordion
              question='Can I get a refund if I don’t attend the meeting? '
              answer='No, you cannot get a refund in this case. If your appointment is confirmed and you don’t attend it, there will be no refunds. Refunds are only available if you haven’t requested to reschedule your appointment.'
            />
            <Accordion
              question='What payment methods can I use to make a payment? '
              answer='You can make payments for appointments using Bank Transfer, Easypaisa, and JazzCash. You can also use your ‘Wallet’ in case you have funds in your wallet.'
            />
            <Accordion
              question='Can I reschedule an appointment?'
              answer='Yes, you can reschedule your appointments. Make sure to reschedule your appointment at least 1 hour prior to your scheduled appointment time. 

Note: Appointments can only be rescheduled when both parties (the lawyer and the client) have confirmed the appointment. There will be no refunds in case of appointment rescheduling. '
            />
            <Accordion
              question='How can I report a problem?'
              answer='If you’re facing a problem related to your appointment or lawyer’s conduct, you can report it in your feedback. When your appointment is completed, you’ll be requested to submit your feedback. 

Tap the ‘Report a Problem’ button at the bottom of the feedback screen. Select the type of problem and explain the issue in detail. 

Note: We recommend sharing adequate proof or evidence (in the form of text, images, and videos) to support your claims.'
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default FAQs;
